export default {"src":"/_next/static/media/play-video.728f033c.svg","height":18,"width":16};